import { render, staticRenderFns } from "./ExportStaffInsuranceParameter.vue?vue&type=template&id=40c8960a"
import script from "./ExportStaffInsuranceParameter.vue?vue&type=script&lang=js"
export * from "./ExportStaffInsuranceParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports